import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { FontAwesome } from '@expo/vector-icons';
import { useSelector } from 'react-redux';
import Style from '../../../../constants/Style';
import PressableStyled from '../../../PressableStyled';
import LocationIcon from '../../../30pxIcons/LocationIcon';
import Colors from '../../../../constants/Colors';
import DateComponent from '../../../DateComponent';
import { DateRange } from '../../../../redux/dateRangeSlice';

interface OccupancyDashboardHeaderProps {
  navigateToMap: () => void,
  navigateToTickets: () => void,
  locationName: string,
  datePickerShown: boolean,
  onConfirm,
  onCompareConfirm,
}

const OccupancyDashboardHeader = ({
  navigateToMap, navigateToTickets, locationName, datePickerShown, onConfirm,
}: OccupancyDashboardHeaderProps) => {
  const range: DateRange = useSelector((state: { dateRange: DateRange }) => state.dateRange);

  return <View style={[Style.row, styles.container]}>
    <View style={Style.row}>
      <PressableStyled onPress={navigateToMap}>
        <LocationIcon color={Colors.light.hereworksBlue500} />
      </PressableStyled>
      <Text style={styles.buildingName}>{locationName ?? '-'}</Text>
      <PressableStyled
        style={Style.row}
        onPress={navigateToTickets}
      >
        <Text style={styles.viewTicketsLabel}>{'View tickets'}</Text>
        <FontAwesome
          name='angle-right'
          size={16}
          color={styles.viewTicketsLabel.color}
        />
      </PressableStyled>
    </View>
    {datePickerShown && <DateComponent
      selectedRange={range.selectedRange}
      onChange={onConfirm}
      onCompareChange={() => { }}
      onOpen={() => { }}
      onConfirm={() => { }}
      startDate={range.start}
      endDate={range.end}
      liveEnabled
      renderLeft
    />}
  </View>;
};

const styles = StyleSheet.create({
  container: {
    padding: 24,
    paddingBottom: 27,
    height: 80,
    zIndex: 2,
  },
  buildingName: {
    fontSize: 22,
    lineHeight: 33,
    fontFamily: 'Poppins_600SemiBold',
    color: Colors.light.hereworksBlack600,
    marginStart: 8,
    marginEnd: 12,
  },
  viewTicketsLabel: {
    fontSize: 14,
    lineHeight: 22,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlue500,
    marginEnd: 8,
  },
});

export default OccupancyDashboardHeader;
